import { render, staticRenderFns } from "./qyjbxx1.vue?vue&type=template&id=5379674a&scoped=true&"
import script from "./qyjbxx1.vue?vue&type=script&lang=js&"
export * from "./qyjbxx1.vue?vue&type=script&lang=js&"
import style0 from "./qyjbxx1.vue?vue&type=style&index=0&id=5379674a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5379674a",
  null
  
)

export default component.exports